import { render, staticRenderFns } from "./LanguageFormModal.vue?vue&type=template&id=c5bd201c"
import script from "./LanguageFormModal.vue?vue&type=script&lang=js"
export * from "./LanguageFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports